<div class="empty-panel"></div>

<div class="side-panel">
    <div class="row">
        <div class="col title">
            {{ "MembershipList.PageTitle" | translate }}
        </div>
    </div>

    <form [formGroup]="searchForm" novalidate class="voffset-20">
        <div class="form-group form-horizontal">
            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "MembershipList.ExpressionLabel" | translate
                        }}</label>
                        <div
                            class="form-group form-horizontal input-with-clear"
                        >
                            <i
                                class="fa fa-keyboard-o number-icon"
                                aria-hidden="true"
                            >
                            </i>
                            <input
                                placeholder="Type in member Id or name"
                                class="form-control"
                                type="text"
                                formControlName="expression"
                            />
                            @if (showExpressionClear()) {
                                <span
                                    class="input-with-clear-img"
                                    (click)="onExpressionClear()"
                                    >&#10006;</span
                                >
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
